import { useAnalytics } from '@/services/analytics';
import { useAuth } from '@/services/auth';
import type { PlanType } from '@/services/billing/plans';
import { useCurrentPlanLabel } from './use-current-plan-label';

/** Analytics for the available-plans grid: the plan-card CTAs, the full-pricing link, and the startup panel. */
export function useAvailablePlansAnalytics() {
  const { account, user } = useAuth();
  const { track } = useAnalytics();
  const currentPlan = useCurrentPlanLabel();
  const requesterName = `${user.first_name} ${user.last_name}`.trim();

  // Fired by all three plan-card CTAs ("Buy now", "Request access", "Let's Talk").
  const trackCtaClicked = (text: string, requestedPlan: PlanType) => {
    void track('plan_billing', 'buyOrRequestAccessClicked', {
      'Account Id': account.id,
      'Current Plan': currentPlan,
      'Requested Plan': requestedPlan,
      Text: text,
    });
  };

  // Fired by the "full plan breakdown" link beneath the grid.
  const trackViewAllFeatures = () => {
    void track('plan_billing', 'viewAllFeaturesClicked', {
      'Account Id': account.id,
      Requester: requesterName,
      'Requester Email': user.email,
      'Requester User Id': user.id,
      'Current Plan': currentPlan,
      'Viewed Feature List': '',
    });
  };

  // Fired by the startup-program panel's "Learn more" / "Apply now" buttons.
  const trackStartupCardClicked = () => {
    void track('onboarding', 'pricingCardButtonClicked', { 'Button Name': 'startup' });
  };

  return { trackCtaClicked, trackViewAllFeatures, trackStartupCardClicked };
}
